import {
  FETCH_PAYMENT_STATUS_LIST_PENDING,
  FETCH_PAYMENT_STATUS_LIST_REJECTED,
  FETCH_PAYMENT_STATUS_LIST_FULFILLED,
} from '../constants/paymentStatuses';

const initialState = {
  pending: true,
  paymentStatuses: [],
  error: {},
};

export const paymentStatuses = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_STATUS_LIST_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PAYMENT_STATUS_LIST_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PAYMENT_STATUS_LIST_FULFILLED:
      return {
        ...state,
        paymentStatuses: action.response.results,
        pending: false,
        error: [],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/paymentStatuses.js